import { render, staticRenderFns } from "./DialogUploadResources.vue?vue&type=template&id=e2a9a9da&scoped=true&"
import script from "./DialogUploadResources.vue?vue&type=script&lang=js&"
export * from "./DialogUploadResources.vue?vue&type=script&lang=js&"
import style0 from "./DialogUploadResources.vue?vue&type=style&index=0&id=e2a9a9da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a9a9da",
  null
  
)

export default component.exports